// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MailOutlinedSvg from "@fishx/icons-svg/es/asn/MailOutlined";
import FishxIcon from '../components/FishxIcon';

var MailOutlined = function MailOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MailOutlinedSvg
  }));
};

MailOutlined.displayName = 'MailOutlined';
export default React.forwardRef(MailOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MailOutlined.js
// module id = 3081
// module chunks = 0